import React from 'react';
import { RadioInput, Alert } from '@guildeducationinc/recess';
import { AlertMessages } from '@src/containers/QuizContainer/types';
import styles from './RadioButtonSet.module.scss';

interface Props {
	alertMessage?: AlertMessages;
	disabled?: boolean;
	onSelect: (option: string) => void;
	options: { label: string; disabled: boolean }[];
	value: string;
}

export const RadioButtonSet: React.FC<Props> = props => {
	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const event = e.target.value ? e.target.value : e.target.innerText;
		props.onSelect(event);
	};

	// Need to trigger handleChange when clicking outside the label & input
	// to work around styling library
	const handleChangeFromDiv = e => {
		handleChange(e);
	};

	return (
		<div className={styles.wrapper}>
			<Alert
				className={styles.disabledAlert}
				display={props.options.some(option => option.disabled)}
				hideClose
				type='info'
			>
				<Alert.Content testid={`alert-content-${props.alertMessage}`}>
					{props.alertMessage}
				</Alert.Content>
			</Alert>
			{props.options.map(option => {
				return (
					<div
						className={styles.inputWrapperForClicking}
						key={`goal-radio-div-${option.label}`}
						onClickCapture={e => handleChangeFromDiv(e)}
						style={option.disabled ? { pointerEvents: 'none' } : {}}
					>
						<RadioInput
							aria-required={true}
							checked={option.disabled ? false : option.label === props.value}
							className={styles.radioButtonContainer}
							data-testid='quiz-radio-item'
							disabled={option.disabled || false}
							label={option.label}
							onChange={e => e.stopPropagation()}
							value={option.label}
						/>
					</div>
				);
			})}
		</div>
	);
};
